import { Component, computed, effect, ElementRef, inject, ViewChild } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { SidebarPanelType } from '../../models/sidebar-panel';
import { NotificationListPanelComponent } from '../notification-list-panel/notification-list-panel.component';
import { NotificationDetailPanelComponent } from '../notification-detail-panel/notification-detail-panel.component';
import { SearchResultsPanelComponent } from '../search-results-panel/search-results-panel.component';
import { SalesOrderDetailPanelComponent } from '../sales-order-detail-panel/sales-order-detail-panel.component';
import { CprDetailPanelComponent } from '../cpr-detail-panel/cpr-detail-panel.component';
import { InvoiceDetailPanelComponent } from '../invoice-detail-panel/invoice-detail-panel.component';

@Component({
  selector: 'app-sidebar-panel',
  imports: [
    NotificationListPanelComponent,
    NotificationDetailPanelComponent,
    SearchResultsPanelComponent,
    SalesOrderDetailPanelComponent,
    CprDetailPanelComponent,
    InvoiceDetailPanelComponent
  ],
  templateUrl: './sidebar-panel.component.html',
  styleUrl: './sidebar-panel.component.scss'
})
export class SidebarPanelComponent {
  protected readonly sidebarService = inject(SidebarService);
  protected readonly SidebarPanelType = SidebarPanelType;

  @ViewChild('sidebarElement') private sidebarElement?: ElementRef<HTMLElement>;
  private previouslyFocusedElement: HTMLElement | null = null;

  protected readonly panelTitle = computed(() => {
    const panel = this.sidebarService.currentPanel();
    if (!panel) return '';
    switch (panel.type) {
      case SidebarPanelType.NotificationList:
        return 'Notifications';
      case SidebarPanelType.NotificationDetail:
        return 'Notification Detail';
      case SidebarPanelType.SearchResults:
        return 'Search';
      case SidebarPanelType.SalesOrderDetail:
        return 'Sales Order Detail';
      case SidebarPanelType.CprDetail:
        return 'Retrieval Detail';
      case SidebarPanelType.InvoiceDetail:
        return 'Invoice Detail';
    }
  });

  constructor() {
    effect(() => {
      if (this.sidebarService.isOpen()) {
        this.previouslyFocusedElement = document.activeElement as HTMLElement;
        setTimeout(() => this.sidebarElement?.nativeElement?.focus());
      } else if (this.previouslyFocusedElement) {
        this.previouslyFocusedElement.focus();
        this.previouslyFocusedElement = null;
      }
    });
  }
}
